import { MdOutlineThumbUpOffAlt } from "react-icons/md";
import { colors } from "../../../constants";
import { useUser } from "../../../context/AuthContext";
import { useDays, TMyGoal } from "../../../context/DaysContext";
import { TDay, TProgress, TLike } from "../../../controllers/days";
import { sameDay, getTime, isYesterday, formatDate, getAmountString } from "../../Goals/Goals";
import { normalizePercentage, getPercentage, getProgressColor } from "../../Stats/Graph";
import { sumDoubleDayProgress } from "../Friends";
import styles from "./UserDays.module.css"
import { TGoal } from "../../../controllers/goals";
import { groupProgressesByDay } from "../../Goals/ProgressDays";
import { Likes } from "../../../components/Likes/Likes";
import { FaThumbsUp } from "react-icons/fa";
export function Day({day, goal, setGoals}: {day: TDay, goal: TGoal, setGoals:  React.Dispatch<React.SetStateAction<TMyGoal[]>>}){
    const user = useUser();
    const {unlikeProgress, likeProgress} = useDays();
    const toggleLikeProgress = async(progress: TProgress, isLiked: boolean) =>{
        let newLike: TLike = {
            userId: user._id,
            username: user.name,
            profileImg: user.profileImg
        }
        let newLikes = [...progress.likes, newLike];
        if(isLiked){
            // unlikeProgress({id: day._id, ...progress}).then(res =>{
            //      //-- console.log("unliked")
                
            //     day.history= day.history.map(pgr =>{
            //         if(pgr.date == progress.date){
            //             let likes: TLike[] = deleteLike(pgr.likes, user._id)
            //             return {...pgr, likes}
            //         }
            //         return pgr
                        
            //     })
            // })
        }else{
            setGoals(prev =>{
                    return prev.map(g =>{
                        if(g._id === goal._id){
                            let newHistory = g.history.map(p =>{
                                if(p._id === progress._id){
                                    return {...progress, likes: newLikes}
                                }
                                return  p;
                            })
                            return {
                                ...g,
                                history: newHistory
                            }
                        }
                        return g
                    })
                 })
            likeProgress({...progress}).then(res =>{
                 //-- console.log("liked");
                 
                //  day.progresses = day.progresses.map(pgr =>{
                //     if(pgr.date == progress.date){
                //         let likes: TLike[] = [...pgr.likes, {userId: user._id, username: user.name, profileImg: user.profileImg}];
                //         return {...pgr, likes}
                //     }
                //     return pgr
                        
                // })
            })
        }
            
    }
    return (
            <div className={styles['single-day']} key={day.date.getTime()} >
            {
                day.progresses.length> 0? day.progresses.map(progress =>{
                    let {date} = progress;
                     //-- console.log("PROGRESS", progress);
                    let dateString = sameDay(date, Date.now())? "Today at "+getTime(date): isYesterday(date)? "Yesterday at "+getTime(date): formatDate(date);
                    let youLiked = Boolean(progress.likes.find(like => like.userId === user._id));
                    return (
                        <div className={styles.progress} key={progress._id}>
                            <div className={styles.header}>
                            <p className={styles.date}>{dateString}</p>
                            <p className={styles["progress-added"]}>+{getAmountString(progress.amount, goal.type)}</p>
                            </div>
                            <p>{progress.notes}</p>
                            <div className={styles.footer} >
                             {progress.likes.length>0?  <Likes likes={progress.likes} /> : null}
                            <FaThumbsUp size={20} color={youLiked? colors.primary : ""} onClick={() =>toggleLikeProgress(progress,youLiked)} className={styles['button-icon']}/>
                           
                            
                            </div>
                        </div>
                    )
                }): <div className='progress'>
                            <div className='header'>
                            <p className='date'>{sameDay(day.date, Date.now())? "Today": isYesterday(day.date)? "Yesterday": new Date(day.date).toLocaleDateString("en-US", {month: "long", day: "numeric"})}</p>
                            </div>
                            <p>no progress...</p>

                        </div>
            }
           
            </div>
    )
}
export default function UserDays({ days, goals, setGoals }: {days: TMyGoal[], goals: TGoal[], setGoals: React.Dispatch<React.SetStateAction<TMyGoal[]>>}){
    
    return (
        <div className={styles.days}>
        
        {goals.length > 0?  goals.map(info =>{
            ////-- console.log("infog", info)
            let goal = info
            let myGoal: TMyGoal | undefined = days.find(day => day._id == info._id);
            if(!myGoal) myGoal = {
                ...info,
                history: []
            }
           
            const {history} = myGoal;
            const progresses = groupProgressesByDay(history);
            let dayProgress = sumDoubleDayProgress(myGoal)
            let normalizedPercentage = normalizePercentage(getPercentage(goal.amount, dayProgress));
            return (
                <div className={styles.day} key={info._id}>
                    <div className={styles.header}>
                        <div className={styles['progress-bar']} style={{width: normalizedPercentage+ "%", backgroundColor: getProgressColor(normalizedPercentage)}}></div>
                        <div className={styles['title-box']}>
                            <p className={styles.title}>{goal.title}</p>
                        </div>
                    </div>
                    <p className={styles.subtitle}> {getAmountString(goal.amount, goal.type)}/{goal.frequency == "daily"?"day" : "week"} </p>
                    {
                        progresses.map(day =><Day day={day} goal={goal} key={day.date.getTime()} setGoals={setGoals}/>)
                    }
                    <div className={styles.footer}><p>Total: {getAmountString(dayProgress, goal.type)}</p></div>
                </div>
            )
        }): <p>No goals yet!</p>}
         </div>
    )
}